(function setFavicon() {
  let favicons = Array.from(document.querySelectorAll(".favicon"));
  if (0 === window.themeVariables.variables.cart.itemCount) {
    console.log("Empty cart");
    favicons.forEach(icon => {
      icon.rel === "shortcut icon" ? icon.href = window.themeVariables.settings.faviconUrl : icon.href = window.themeVariables.settings.faviconAppleUrl;
      console.log("icon urls:", window.themeVariables.settings.faviconUrl, window.themeVariables.settings.faviconAppleUrl);
    })
  } else {
    console.log("Filled cart");
    favicons.forEach(icon => {
      icon.rel === "shortcut icon" ? icon.href = window.themeVariables.settings.faviconFilledUrl : icon.href = window.themeVariables.settings.faviconFilledAppleUrl;
      console.log("icon filled urls:", window.themeVariables.settings.faviconFilledUrl, window.themeVariables.settings.faviconFilledAppleUrl);
    })
  }
})();
